var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsIn, IsOptional, IsString, MaxLength } from 'class-validator';
import { ManfrediteDeleteReasonValues } from './manfredite-delete-reason';
/**
 * Affected endpoints
 * DELETE /manfredite
 */
export class ManfrediteDeleteRequest {
}
__decorate([
    Expose(),
    IsIn(ManfrediteDeleteReasonValues),
    __metadata("design:type", String)
], ManfrediteDeleteRequest.prototype, "reasonForLeaving", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    MaxLength(255),
    __metadata("design:type", String)
], ManfrediteDeleteRequest.prototype, "otherReason", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    MaxLength(4000),
    __metadata("design:type", String)
], ManfrediteDeleteRequest.prototype, "comments", void 0);
//# sourceMappingURL=manfredite-delete.request.js.map